module.exports = __webpack_public_path__ + "img/palm2_13.20b5502d.png";